const slackContact = [
  {
    name: 'Gin',
    avatar: '',
    slackId: 'UF104GRDG'
  },
  {
    name: 'Cian',
    avatar: '',
    slackId: 'U69G3BX7C'
  },
  {
    name: 'Jeffery',
    avatar: '',
    slackId: 'UAU0MKGKY'
  },
  {
    name: 'Henry',
    avatar: '',
    slackId: 'UBH4F8CHZ'
  }
]

export { slackContact }
